import L, { get, latLngBounds, openOn, zoomOntoMarker, latLng } from "leaflet";
import { GestureHandling } from "leaflet-gesture-handling";
import { useEffect, useRef, useState } from "react";
import { useMap } from "react-leaflet";
import { sortByDistance } from "./sortByDistance";
import "leaflet.heat";
import { isUnderDistance } from "./coordinatesGps";

function ChangeView({
  center,
  zoom,
  markers,
  selectedInstitution,
  data,
  customMarkerRefs,
  mapRef,
  setMapRef,
  clusterRef,
  popupRefs,
  sizeState,
  userCurrentPosition,
  selectedGeoAdress,
  setFilteredEntities,
}) {
  const map = useMap();
  const [currentPopup, setCurrentPopup] = useState();
  const [sortedEntities, setSortedEntities] = useState(null);
  const [locationMarker, setLocationMarker] = useState(null);
  const [locationCircle, setLocationCircle] = useState(null);

  // const mapReff = map;

  // function to add fullScreen control
  const fullScreenControl = () => {
    const validPositions = ["topleft", "topright", "bottomleft", "bottomright"];

    if (validPositions.includes(process.env.REACT_APP_FULLSCREENCONTROLE)) {
      map.addControl(new L.Control.Fullscreen({
        position: process.env.REACT_APP_FULLSCREENCONTROLE,
        title: {
          'false': 'View Fullscreen',
          'true': 'Exit Fullscreen'
        }
      }));
    }
  }

  // react render generate when save file same in build ?
  useEffect(() => {
    fullScreenControl()
  }, []) // Keep to have only one Fullscreen controle create

  //--- Add google map gesture handling
  map.gestureHandling.enable();

  //--- Change map bounds when the marker list change to fit the displayed markers onto the map
  const [bounds, setBounds] = useState(() => {
    let markerBounds = latLngBounds([]);
    if (markers.length && markers.length > 0 && !selectedInstitution) {
      markers.forEach((marker) => {
        if (marker != null) {
          //--- with custom markers component
          markerBounds.extend([
            marker.props.entity.latitude,
            marker.props.entity.longitude,
          ]);
        }
      });
    }
    return markerBounds;
  });

  let markerBounds = latLngBounds([]);

  useEffect(() => {
    setMapRef(map);
  }, [map]);

  useEffect(() => {
    if (markers.length && markers.length > 0 && !selectedInstitution) {
      markers.forEach((marker) => {
        if (marker != null) {
          //--- with custom markers component
          markerBounds.extend([
            marker.props.entity.latitude,
            marker.props.entity.longitude,
          ]);
        }
      });
      if (!selectedGeoAdress) {
        map.fitBounds(markerBounds, { maxZoom: changeZoom() });
        setBounds(markerBounds);
      }
    }
  }, [data, selectedInstitution, sizeState, selectedGeoAdress]);

  useEffect(() => {
    if (selectedGeoAdress) {

      // Ajoutez un popup et l'ouvrez immédiatement
      // if (process.env.REACT_APP_POPUP === "true") {
      //   locationMarkerInstance.bindPopup('<div class="gl-popup monappart"><p>Vous êtes ici</p></div>', {
      //     className: "my-marker-popup",
      //     autoPanPaddingTopLeft: [50, 50],
      //     autoPanPaddingBottomRight: [50, 50],
      //   }); // Ouvre la popup immédiatement
      // }


      const addressLtnLgn = L.latLng(
        parseFloat(selectedGeoAdress.geometry.coordinates[1]),
        parseFloat(selectedGeoAdress.geometry.coordinates[0])
      );

      const radius = 30000; // by meters
      const locationCircleInstance = L.circle(addressLtnLgn, {
        radius: radius,
        color: "#026B70",
        fillColor: "#026B70",
        fillOpacity: 0.2,
      });

      const sortedEntitiesByDistance = sortByDistance(selectedGeoAdress, data);

      setSortedEntities(() => sortedEntitiesByDistance);

      if (selectedGeoAdress.properties.type === "departement") {
        map.flyTo(addressLtnLgn, 9);
      } else if (selectedGeoAdress.properties.type === "region") {
        map.flyTo(addressLtnLgn, 8.5);
      } else {
        map.fitBounds(
          [
            [
              sortedEntitiesByDistance[0].latitude,
              sortedEntitiesByDistance[0].longitude,
            ],
            [
              selectedGeoAdress.geometry.coordinates[1],
              selectedGeoAdress.geometry.coordinates[0],
            ],
          ],
          {
            maxZoom: process.env.REACT_ZOOM_SELECTEDGEOADRESS ? process.env.REACT_ZOOM_SELECTEDGEOADRESS : 9,
            padding: [50, 50],
          }
        );


        if (locationCircle && process.env.REACT_APP_POLYGON_ME === "true") {
          map.removeLayer(locationCircle);
          map.addLayer(locationCircleInstance);
          setLocationCircle(locationCircleInstance);
        } else {
          map.addLayer(locationCircleInstance);
          setLocationCircle(locationCircleInstance);
        }
      }

    } else {
      if (locationMarker) {
        map.removeLayer(locationMarker);
        setLocationMarker(null);
      }
      if (locationCircle && process.env.REACT_APP_POLYGON_ME === "true") {
        map.removeLayer(locationCircle);
        setLocationCircle(null);
      }
    }
  }, [selectedGeoAdress]);

  useEffect(() => {
    if (selectedGeoAdress) {

      const icon = L.divIcon({
        html: `
         <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="40px" height="40px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
        <g>
          <path fill="#999999" class="st5" d="M425.3,89.7C386.4,33.3,324.6,1,256,1C187.4,1,125.7,33.3,86.7,89.7c-38.7,56.1-47.7,127-24,189.8
            c6.3,17.1,16.4,33.8,29.9,49.4l149.8,175.9c3.4,4,8.4,6.3,13.6,6.3c5.2,0,10.2-2.3,13.6-6.3l149.7-175.9
            c13.5-15.7,23.6-32.3,29.9-49.3C473,216.7,464,145.7,425.3,89.7z M256,306.5c-55.1,0-99.9-44.8-99.9-99.9s44.8-99.9,99.9-99.9
            s99.9,44.8,99.9,99.9C355.9,261.7,311.1,306.5,256,306.5z"/>
        </g>
        </svg>
      `,
        iconSize: L.point(35, 35, true),
        iconAnchor: [17, 17],
        className: "custom-marker-cluster custom-marker-cluster-me",
      });


      const locationMarkerInstance = L.marker(
        [selectedGeoAdress.geometry.coordinates[1], selectedGeoAdress.geometry.coordinates[0]],
        { icon }
      );

      if (locationMarker) {
        map.removeLayer(locationMarker);
        map.addLayer(locationMarkerInstance);
        setLocationMarker(locationMarkerInstance);
      } else {
        map.addLayer(locationMarkerInstance);
        setLocationMarker(locationMarkerInstance);
      }

      if (process.env.REACT_APP_POPUP_LOCAL_ME === "true") {
        const datas = data.filter((entity) => {
          return isUnderDistance(entity, {
            longitude: selectedGeoAdress.geometry.coordinates[0],
            latitude: selectedGeoAdress.geometry.coordinates[1],
          }, 30)
        })
        const getMessagePopup = (length) => {
          if (length > 1) return `${length} biens sont présents dans un rayon de 30km.`
          if (length === 1) return `${length} unique bien est présent dans un rayon de 30km.`
          return `Aucun bien disponible <br/>dans un rayon de 30km.`
        }
        const message = getMessagePopup(datas?.length)
        locationMarkerInstance.bindPopup(`<div class="gl-popup monappart"><p>${message}</p></div>`, {
          className: "my-marker-popup",
          autoPanPaddingTopLeft: [50, 50],
          autoPanPaddingBottomRight: [50, 50],
        }).openPopup();
      }
    }
  }, [selectedGeoAdress, data])

  useEffect(() => {
    if (sortedEntities) {
      setFilteredEntities(sortedEntities);
    }
  }, [sortedEntities]);

  const closePopup = () => {
    if (process.env.REACT_APP_POPUP) {
      if (currentPopup) {
        map.closePopup(currentPopup);
        setCurrentPopup(null);
      }
    }
  };

  const delay = (n) => {
    n = n || 2000;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, n);
    });
  };

  async function zoomSmoothly(cluster = null, marker = null, popup) {
    if (cluster && marker) {
      await cluster.zoomToShowLayer(marker);
      await delay(300);
    }
    if (popup) {
      await map.openPopup(popup);
    }
  }

  const changeZoom = () => {
    if (
      process.env.REACT_APP__DEFAULT_MAXZOOM &&
      typeof Number(process.env.REACT_APP__DEFAULT_MAXZOOM) === "number"
    ) {
      return Number(process.env.REACT_APP__DEFAULT_MAXZOOM);
    } else {
      return null;
    }
  };

  const zoomOntoMarker = () => {
    if (process.env.REACT_APP_POPUP) {
      if (selectedInstitution) {
        customMarkerRefs.current.forEach((markerRef, i) => {
          const marker = markerRef.current;
          const cluster = clusterRef.current;
          if (marker) {
            const popup = marker._popup;
            if (marker.options.calc.id === selectedInstitution.id) {
              const parentElement = cluster.getVisibleParent(marker);
              if (parentElement) {
                if (
                  !parentElement._preSpiderfyLatlng &&
                  parentElement._childCount
                ) {
                  zoomSmoothly(cluster, marker, popup);
                } else {
                  setCurrentPopup(popup);
                  zoomSmoothly(null, null, popup);
                }
              } else {
                setCurrentPopup(popup);
                zoomSmoothly(null, null, popup);
              }
            }
          }
        });
      }
    } else if (
      !process.env.REACT_APP_POPUP &&
      process.env.REACT_APP_CLUSTER > 0
    ) {
      if (selectedInstitution) {
        customMarkerRefs.current.forEach((markerRef, i) => {
          const marker = markerRef.current;
          const cluster = clusterRef.current;
          if (marker) {
            if (marker.options.calc.id === selectedInstitution.id) {
              const parentElement = cluster.getVisibleParent(marker);
              if (parentElement) {
                if (
                  !parentElement._preSpiderfyLatlng &&
                  parentElement._childCount
                ) {
                  zoomSmoothly(cluster, marker, "");
                }
              }
            }
          }
        });
      }
    }
  };

  //--- Add offset (popup Info width) to the map bounds when an entity is selected so the corresponding marker is centered
  useEffect(() => {
    closePopup();
    let timer = false;
    if (selectedInstitution) {
      if (window.innerWidth > 992) {
        let markerPosition = map.latLngToContainerPoint([
          parseFloat(selectedInstitution.latitude),
          parseFloat(selectedInstitution.longitude),
        ]);
        const offset =
          process.env.REACT_APP_INSTITUTIONLAYER === "true" ? 215 : 0;
        if (process.env.REACT_APP_SIDEBAR === "right") {
          let newPosition = L.point([
            markerPosition.x + offset,
            markerPosition.y,
          ]);
          let newLatLng = map.containerPointToLatLng(newPosition);
          map.setView(newLatLng, map.getZoom());
          timer = setTimeout(() => {
            zoomOntoMarker();
          }, 500);
        } else {
          let newPosition = L.point([
            markerPosition.x - offset,
            markerPosition.y,
          ]);
          let newLatLng = map.containerPointToLatLng(newPosition);
          map.setView(newLatLng, map.getZoom());
          timer = setTimeout(() => {
            zoomOntoMarker();
          }, 500);
        }
      } else {
        let markerPosition = map.latLngToContainerPoint([
          parseFloat(selectedInstitution.latitude),
          parseFloat(selectedInstitution.longitude),
        ]);
        let newPosition = L.point([
          markerPosition.x,
          markerPosition.y + 270 / 2,
        ]);
        let newLatLng = map.containerPointToLatLng(newPosition);
        map.setView(newLatLng, map.getZoom());
        timer = setTimeout(() => {
          zoomOntoMarker();
        }, 500);
      }
    } else {
      // map.fitBounds(bounds);
      // unZoom();
    }
    return () => {
      clearTimeout(timer);
    };
  }, [selectedInstitution]);

  return null;
}

export default ChangeView;
